import * as React from 'react';
import { connect } from 'react-redux';

import { navigate } from '~/router';

import Form from '../../components/auth/LoginForm';
import { login } from '../../actions/auth';
import { redirectToHome } from '../../helpers';
import { initIfAuthorized } from "~/apps/shared/services/auth";


class LoginForm extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const { dispatch } = this.props;
    const { username, password } = values;

    return dispatch(login(username, password))
      .then((data) => {
        const user = data.entities.users[data.result.user];

        if (user.forcePasswordChange) {
          navigate('forcePasswordChange');
        } else {
          // TODO: Read from state
          const org = data.entities.organizations[user.organizationId];

          initIfAuthorized(user).finally(() => {
            redirectToHome(user, org);
          });
        }
      });
  }

  render() {
    const { errorMessage } = this.props;

    return (
      <Form
        onSubmit={ this.onSubmit }
        error={ errorMessage }
        submitting={false} // TODO need other (dynamic) submitting value
      />
    );
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

const mapStateToProps = (state) => {
  return {
    loading: state.shared.auth.loading,
    errorMessage: state.shared.auth.errorMessage,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
